import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=eee0a7ac&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eee0a7ac')) {
      api.createRecord('eee0a7ac', component.options)
    } else {
      api.reload('eee0a7ac', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=eee0a7ac&", function () {
      api.rerender('eee0a7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/loading/src/loading.vue"
export default component.exports